import React, { useState } from "react";
import {
  Design,
} from "../../../core/models/entities/Design";
import { ApprovalType, getApprovalBorderColor } from "../../../core/models/entities/BaseLogo";
import { ApprovalStatus } from "../../../core/models/entities/Approval";

interface MultiDesignApprovalCarouselProps {
  designs: Design[];
  onSelectDesign: (design: Design, index: number) => void;
  selectedIndex: number;
  approvalType?: ApprovalType;
}

interface DesignCarouselItemProps {
  design: Design;
  isSelected: boolean;
  onClick: () => void;
  approvalType?: ApprovalType;
}

function DesignCarouselItem({
  design,
  isSelected,
  onClick,
  approvalType,
}: DesignCarouselItemProps) {
  // Determine border color based on ApprovalType-specific status
  const borderColorClass = getApprovalBorderColor(design.approval, approvalType);

  return (
    <div
      className={`relative min-w-[130px] min-h-[85px] w-[130px] h-[85px] rounded-sm border-solid bg-white text-gray-600 hover:cursor-pointer ${
        isSelected
          ? `${borderColorClass} shadow-sm`
          : `${borderColorClass} bg-white hover:opacity-80`
      }`}
      onClick={onClick}
    >
      <div className="flex justify-center items-center h-full p-1">
        <img
          className="w-full h-full object-contain"
          src={design.displayImage?.lowResUrl}
          alt={design.title || "Design"}
        />
      </div>
    </div>
  );
}

export function MultiDesignApprovalCarousel({
  designs,
  onSelectDesign,
  selectedIndex,
  approvalType,
}: MultiDesignApprovalCarouselProps) {
  const designItems = designs.map((design, index) => (
    <DesignCarouselItem
      key={index}
      design={design}
      isSelected={index === selectedIndex}
      onClick={() => onSelectDesign(design, index)}
      approvalType={approvalType}
    />
  ));

  return (
    <div>
      <p className="uppercase text-xs font-semibold pb-1.5">
        DESIGNS ({designs.length})
      </p>
      <div className="flex space-x-1.5 overflow-x-auto overflow-y-hidden pt-1.5 mt-[-6px] pb-1 my-1 relative pr-1.5">
        {designItems}
      </div>
    </div>
  );
}
